import React from 'react';
import { AlertCircleIcon, XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  return <section className="w-full bg-[#0b0b0b] py-16 md:py-24 px-4 relative overflow-hidden border-t border-white/5" data-id="element-284">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#0b0b0b] via-[#c9a24a] to-[#0b0b0b] opacity-30" data-id="element-285"></div>
      <div className="absolute -top-40 -right-40 w-96 h-96 bg-[#c9a24a]/5 rounded-full blur-3xl pointer-events-none" data-id="element-286"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-287">
        <div className="text-center mb-10 md:mb-16" data-id="element-288">
          <div className="inline-flex items-center justify-center gap-2 bg-[#c9a24a]/10 text-[#c9a24a] px-4 py-2 rounded-full text-[10px] md:text-sm font-black uppercase tracking-widest mb-4 border border-[#c9a24a]/20" data-id="element-289">
            <AlertCircleIcon className="w-4 h-4 md:w-5 md:h-5" data-id="element-290" />
            La realidad del barbero
          </div>
          <h2 className="text-2xl md:text-5xl font-black text-white leading-tight mb-6" data-id="element-291">
            Si esto te pasa, necesitás cambiar{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#e53935] to-[#ef5350]" data-id="element-292">
              cómo estás aprendiendo
            </span>
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-293">
          {['Sentís que los cortes no quedan como deberían', 'Ves videos pero no sabés aplicarlo', 'No tenés seguridad cuando cortás', 'Dependés de copiar sin entender', 'Sabés que podrías hacerlo mucho mejor'].map((pain, index) => <div key={index} className={`bg-[#141418] border border-white/10 rounded-xl md:rounded-2xl p-5 md:p-8 shadow-sm hover:shadow-md transition-shadow flex items-start gap-4 ${index === 4 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-294">
              <div className="bg-[#e53935]/10 p-2 md:p-3 rounded-lg flex-shrink-0 mt-0.5 border border-[#e53935]/20" data-id="element-295">
                <XCircleIcon className="w-5 h-5 md:w-6 md:h-6 text-[#e53935]" data-id="element-296" />
              </div>
              <p className="text-gray-300 font-bold text-sm md:text-xl leading-snug" data-id="element-297">
                {pain}
              </p>
            </div>)}
        </div>

        <div className="mt-12 md:mt-16 text-center" data-id="element-298">
          <p className="text-gray-500 text-sm md:text-lg font-medium max-w-2xl mx-auto" data-id="element-299">
            Seguir viendo tutoriales sueltos en YouTube no te va a dar la
            estructura que necesitás para cobrar lo que vale tu trabajo.
          </p>
        </div>
      </div>
    </section>;
}